<template>
  <div class="content-bg">
    <el-container class="container">
      <el-header height="80px">
        <div class="header-title">
          <div class="header-border"></div>
          <slot name="header-text" class="header-text"></slot>
        </div>
      </el-header>
      <el-main style="padding:0;">
        <slot name="main-content"></slot>

      </el-main>
      <el-footer height="90px">
        <div class="footer-btn">
          <slot name="button"></slot>
          <!-- <el-button size="medium" round>中等按钮</el-button> -->
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {

}
</script>

<style lang='less' scoped>
.header-border {
  // margin-top: 0.5rem;
}
.container {
  .el-header {
    display: flex;
    align-items: center;
    .header-title {
      margin: 0 auto;
      color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 1rem;
      .header-border {
        width: 60px;
        height: 2px;
        background: #fff;
        // border-radius: 30%;
        margin-bottom: 0.8rem;
      }
    }
  }
  .el-main {
    overflow: hidden;
  }
  .el-footer {
    display: flex;
    align-items: center;

    justify-content: center;
  }
}
.el-button {
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #6dab26;
  color: #fff;
}
</style>